export function alertasReducer(state={},action){
  switch (action.type){
    case "MSGERROR":
      return {msgErr:action.msg};
    case "MSGSUCCESS":
      return {msgSucc:action.msg};
    case "MSGWARNING":
      return {msgWar:action.msg};
    case "CLEANMSGS":
      return {};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/alertsReducer.js